var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.844 15V6.28l3.125 3.126.53-.53L5.734 5.11a.37.37 0 00-.53 0l-3.77 3.765.53.53 3.13-3.125V15h.75zM14.8 14.889l3.764-3.765-.53-.53-3.124 3.125V5h-.75v8.72l-3.13-3.125-.53.53 3.77 3.765a.369.369 0 00.53 0z",
    fill: "#000"
  })));
}
export default SvgSortIcon;